<template>
	<div class="main">
		<header class="page-title">
			<h2>Coupons</h2>
			<div class="ml-auto">
				<a @click="showModal(0)" class="btn btn-md btn-success"><i class="fas fa-plus"></i> Add New Coupon</a>
			</div>
		</header>
		<div class="table-reponsive">
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Provider</th>
						<th>Discount Text</th>
						<th>Affiliate Tag</th>
						<th>Status</th>
						<th>Shortcode</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(coupon,index) in orderedCoupons">
						<td>{{ coupon.id }}</td>
						<td>{{ coupon.provider_name }}</td>
						<td>{{ coupon.discount_bold }} {{ coupon.discount_normal }}</td>
						<td>{{ coupon.affiliate_link }}</td>
						<td>
							<span class="badge badge-primary" v-if="coupon.active">Active</span>
							<span class="badge badge-default" v-else>Inactive</span>
						</td>
						<td><code class="code-inline">[[post-object type="coupon" id="{{ coupon.id }}" /]]</code></td>
						<td class="nowrap">
							<a @click="copyCoupon(coupon.id)" class="btn btn-icon btn-primary"><i class="fas fa-clone" title="Copy Shortcode"></i></a>
							<a @click="showModal(coupon.id)" class="btn btn-icon btn-primary"><i class="fas fa-pencil-alt" title="Edit"></i></a>
							<a @click="deleteCoupon(coupon.id)" class="btn btn-icon btn-danger"><i class="fas fa-trash-alt" title="Trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title" v-show="currentCoupon.id === 0">Add New Coupon</h4>
				<h4 class="modal-title" v-show="currentCoupon.id !== 0">Edit Coupon</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six-lg">
						<label for="provider">Provider</label>
						<select @change="loadAffiliateLinks" id="provider" required v-model="currentCoupon.provider_id">
							<option v-show="currentCoupon.provider_id === null" value="0">Select a provider</option>
							<option :value="provider.id" v-for="provider in providers">{{ provider.name }}</option>
						</select>
						<p class="input-error" v-show="errors.errors.provider_id !== ''">{{ errors.errors.provider_id }}</p>
					</div>
					<div class="form-group six-lg">
						<label for="affiliate_link">Affiliate Tag</label>
						<select :disabled="!currentCoupon.provider_id" id="affiliate_link" v-model="currentCoupon.affiliate_link">
							<option v-for="tag in affiliateLinks" :value="tag">{{ tag }}</option>
						</select>
						<p class="input-error" v-show="errors.errors.affiliate_link !== ''">{{ errors.errors.affiliate_link }}</p>
					</div>
				</div>
				<div class="flex box start">
					<div class="form-group six-lg">
						<label for="discount-bold">Discount Bold Text</label>
						<input id="discount-bold" name="discount-bold" required type="text" v-model="currentCoupon.discount_bold">
						<p class="input-error" v-show="errors.errors.discount_bold !== ''">{{ errors.errors.discount_bold }}</p>
					</div>
					<div class="form-group six-lg">
						<label for="discount-regular">Discount Regular Text</label>
						<input id="discount-regular" name="discount-regular" required type="text" v-model="currentCoupon.discount_normal">
						<p class="input-error" v-show="errors.errors.discount_normal !== ''">{{ errors.errors.discount_normal }}</p>
					</div>
				</div>
				<div class="flex box start">
					<div class="form-group six-lg">
						<label for="supporting-text">Supported Text</label>
						<input id="supporting-text" name="supporting-text" required type="text" v-model="currentCoupon.supporting_text">
						<p class="input-error" v-show="errors.errors.supporting_text !== ''">{{ errors.errors.supporting_text }}</p>
					</div>
					<div class="form-group six-lg">
						<label for="button-text">Button Text</label>
						<input id="button-text" name="button-text" required type="text" v-model="currentCoupon.button_text">
						<p class="input-error" v-show="errors.errors.button_text !== ''">{{ errors.errors.button_text }}</p>
					</div>
				</div>
				<label class="label-checkbox">
					<input checked type="checkbox" v-model="currentCoupon.active">
					Active
				</label>
			</template>
			<template slot="footer">
				<a @click="closeModal" class="btn btn-md btn-primary modal-close"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveCoupon" class="btn btn-md btn-success" v-show="currentCoupon.id === 0"><i class="fas fa-save"></i> Add New Coupon</a>
				<a @click="updateCoupon" class="btn btn-md btn-success" v-show="currentCoupon.id !== 0"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from '../Modal/DefaultModal.vue';
	import Errors from '../../Utils/Errors.js';
	import VueSelect from '../../../../node_modules/vue-select';
	import Clipboard from '../../../../node_modules/v-clipboard';

	Vue.use(Clipboard);

	export default {
		props: {
			data: {
				type: Object
			}
		},
		components: {
			modal,
			"vue-select": VueSelect,
		},
		data() {
			return {
				dataBlock: this.data,
				providers: this.data.providers,
				isModalVisible: false,
				currentCoupon: {
					id: 0,
					provider_id: null,
					affiliate_link: null,
					discount_bold: '',
					discount_normal: '',
					supporting_text: '',
					button_text: '',
					active: true,
				},
				affiliateLinks: [],

				errors: new Errors()
			}
		},
		computed: {
			orderedCoupons: function () {
				return _.orderBy(this.data.coupons, ['provider_name', 'active'], ['asc', 'desc'])
			}
		},
		methods: {
			showModal: function (id) {
				this.loadCoupon(id);
				this.isModalVisible = true;
			},
			closeModal: function () {
				this.isModalVisible = false;
			},
			loadCoupon: function (id) {
				if (id === 0) {
					this.currentCoupon = {
						id: 0,
						provider_id: null,
						affiliate_link: null,
						discount_bold: '',
						discount_normal: '',
						supporting_text: '',
						button_text: '',
						active: true,
					};
				} else {
					this.currentCoupon = this.dataBlock.coupons[id];
					this.loadAffiliateLinks();
				}
			},
			loadAffiliateLinks: function () {
				let vm = this;

				axios.post('/api/' + vm.$selectedSite.slug + '/coupons/getaffiliates',
					{
						providerId: vm.currentCoupon.provider_id,
					},
				).then(function (response) {
					vm.affiliateLinks = response.data.affiliateLinks;
				}).catch(function (e) {
					vm.errors.record(e.response.data);
				});
			},
			saveCoupon: function() {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/coupon/', vm.currentCoupon)
					.then(function (response) {
						if (response) {
							vm.$toastr.success('Coupon saved successfully.');
							setTimeout(function () {
								location.reload();
							}, 1000);
						} else {
							vm.$toastr.error('Coupon save failed.', 'Error');
						} // if
					}).catch(function (e) {
						vm.$toastr.error('Coupon saving failed.', 'Error');
						vm.errors.record(e.response.data);
					});
			},
			updateCoupon: function () {
				let vm = this;

				axios.put('/api/' + vm.$selectedSite.slug + '/coupon/' + vm.currentCoupon.id, vm.currentCoupon)
					.then(function (response) {
						if (response) {
							vm.$toastr.success('Coupon updated successfully.');
							setTimeout(function () {
								location.reload();
							}, 1000);
						} else {
							vm.$toastr.error('Coupon update failed.', 'Error');
						} // if
					}).catch(function (e) {
						vm.$toastr.error('Coupon update failed.', 'Error');
						vm.errors.record(e.response.data);
					});
			},
			deleteCoupon: function (id) {
				let vm = this;

				vm.$dialog.confirm('Are you sure you want to delete this coupon?')
					.then((dialog) => {
						axios.delete('/api/' + this.$selectedSite.slug + '/coupon/' + id)
							.then(response => {
								vm.$toastr.success('Coupon deleted successfully.');
								setTimeout(function () {
									location.reload();
								}, 1000);
							})
							.catch(errors => {
								dialog.close();
								vm.$toastr.error('Coupon delete failed.', 'Error');
							});
					})
					.catch(error => {
						vm.$toastr.error('Delete aborted.');
					});
			},
			copyCoupon(id) {
				let vm = this;
				this.$clipboard('[[post-object type="coupon" id="' + id + '" /]]');
				vm.$toastr.success('Coupon shortcode copied', 'Success');
			}
		}
	}
</script>

<style scoped>

</style>
